import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a ResizeObserver error
    if (error?.message?.includes?.('ResizeObserver')) {
      // Suppress ResizeObserver errors
      return { hasError: false };
    }
    // For other errors, show error UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a ResizeObserver error
    if (error?.message?.includes?.('ResizeObserver')) {
      // Suppress ResizeObserver errors silently
      return;
    }
    
    // Log other errors for debugging
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for actual errors
      return (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100vh',
          background: '#0A1128',
          color: '#E8E8E8',
          fontFamily: 'Century Gothic, sans-serif'
        }}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Something went wrong</h1>
            <p style={{ color: '#B0B0B0' }}>Please refresh the page</p>
            <button 
              onClick={() => window.location.reload()}
              style={{
                marginTop: '20px',
                padding: '10px 20px',
                background: '#4A9FFF',
                color: '#FFF',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
